<script lang="ts">
  import {slide} from 'svelte/transition';
  import InlineSVG from 'svelte-inline-svg';

  import {NotificationTypes} from '../../types/notifications';

  import {
    showNotification,
    notificationType,
    notificationTitle,
    notificationDescription,
    notification
  } from '../../stores/notifications';

  import infoIcon from '../../assets/icons/info.svg';
  import successIcon from '../../assets/icons/success.svg';
  import warningIcon from '../../assets/icons/warning.svg';
  import errorIcon from '../../assets/icons/error.svg';
  import closeIcon from '../../assets/icons/cross.svg';

  import Note from '../note/Note.svelte';
  import IconButton from '../icon-button/IconButton.svelte';
</script>

<style>
  .notification {
    z-index: 20;
    position: fixed;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 0.5rem;
    pointer-events: none;
  }

  @media (min-width: 640px) {
    .notification {
      margin: 0 1rem;
    }
  }

  .notification > :global(div) {
    max-width: 30rem;
    border-radius: var(--ubilabs-note-border-radius);
    background-color: var(--ubilabs-white);
    box-shadow: var(--ubilabs-box-shadow);
    pointer-events: all;
  }

  .text {
    padding-right: 2.5rem;
  }

  .text > * {
    margin: 0;
  }

  .text + :global(button) {
    position: absolute;
    top: 0.125rem;
    right: 0.125rem;
    color: inherit;
  }
</style>

{#if $showNotification}
  <div class="notification {$notificationType}" role="alert">
    <div transition:slide|local>
      <Note variant={$notificationType}>
        <div slot="icon">
          {#if $notificationType === NotificationTypes.ERROR}
            <InlineSVG src={errorIcon} />
          {:else if $notificationType === NotificationTypes.WARNING}
            <InlineSVG src={warningIcon} />
          {:else if $notificationType === NotificationTypes.SUCCESS}
            <InlineSVG src={successIcon} />
          {:else}
            <InlineSVG src={infoIcon} />
          {/if}
        </div>
        <div class="text">
          <h4>{$notificationTitle}</h4>
          <p>{$notificationDescription}</p>
        </div>
        <IconButton on:click={() => notification.hide()}>
          <InlineSVG src={closeIcon} />
        </IconButton>
      </Note>
    </div>
  </div>
{/if}
